import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { List } from '@site-mate/dashpivot-shared-library';

import { ListsService } from 'app/lists/lists.service';

type ListDataMap = Map<string, List>;
type ListIsLoadingMap = Map<string, boolean>;
@Injectable({
  providedIn: 'root',
})
export class TemplateListsService {
  private listDataMapSubject = new BehaviorSubject<ListDataMap>(new Map());
  private listIsLoadingMapSubject = new BehaviorSubject<ListIsLoadingMap>(new Map());

  public listIsLoading$ = this.listIsLoadingMapSubject.asObservable();
  public listDataMap$ = this.listDataMapSubject.asObservable();

  constructor(private readonly listsService: ListsService) {}

  get listDataMap(): Map<string, List> {
    return this.listDataMapSubject.value;
  }
  get listIsLoadingMap(): Map<string, boolean> {
    return this.listIsLoadingMapSubject.value;
  }

  setListData(listId: string) {
    if (!this.listIsLoadingMap.has(listId) && !this.listDataMap.has(listId)) {
      this.setListIsLoading(listId, true);

      this.listsService.getList(listId).subscribe((list) => {
        const latestDataMapValue = this.listDataMap;
        latestDataMapValue.set(listId, list);
        this.listDataMapSubject.next(latestDataMapValue);
        this.setListIsLoading(listId, false);
      });
    }
  }

  getListData(listId: string) {
    if (!this.listDataMap.has(listId)) {
      this.setListData(listId);
    }
    return this.listDataMap.get(listId);
  }

  emptyListData(listId: string) {
    this.listDataMap.delete(listId);
  }

  emptyAllListData() {
    this.listDataMap.clear();
  }

  setListIsLoading(listId: string, isLoading: boolean) {
    this.listIsLoadingMap.set(listId, isLoading);
    this.listIsLoadingMapSubject.next(this.listIsLoadingMap);
  }
}
